import AccordionComponent from "../home/accordion/accordion";
import CardswiperComponent from "../home/card-swiper";
import DashboardComponent from "../home/dashboard";
import NotificationComponent from "../home/notificationCards";
import PromoswiperComponent from "../home/promo-swiper";
import QuicklinksComponent from "../home/quicklinks";
import PassportCountriesBanner from "../roaming/PassportCountriesBanner";
import PassportCountriesTabs from "../roaming/PassportCountriesTabs";
//import RoamingCountriesComponent from "../../pages/roaming/roaming-countries";
import RoamingMultiCountriesList from "../roaming/RoamingMultiCountriesList";
import MoreAccountsList from "../common/more-accounts-list";
import NojoomUserInfo from '../nojoom/nojoom-user-info';
import NojoomDashboard from '../nojoom/nojoom-dashboard'
import NojoomEnrollNow from "../nojoom/nojoom-enroll-now";
import XpressProfitBalance from "../xpress-profit/xpress-profit-balance";
import LoadBalance from '../xpress-profit/load-balance';
import TransferBalance from '../xpress-profit/transfer-balance';
import TransactionHistory from "../xpress-profit/transaction-history";
import XpressProfitBanner from "../xpress-profit/xpress-profit-banner";
import OutofInternet from "../home/outof-internet";
import RecentTransactionswiperComponent from "../home/recent-transaction-swiper";
// import BannerCarousel from "../home/banner-carousel";
import BannerCarousel from "../home/banner-carousel-theme";
import OffersForYou from "../home/OffersForYou"
import Promotions from "../home/promotions/Promotions";
import PromoSwiper from '../../components/roaming/promo-swiper';
import OoredooAdd from "../home/OoredooAdd";
import NojoomEarnPoints from '../nojoom/nojoom-earn-points';
import NojoomBanner from "../nojoom/nojoom_banner";
import Banner from '../manage-account/banner';
import SmartPayCard from "../smart-pay/smart-pay-card";
import BalanceCard from "../manage-account/balance-card";
import BasicServices from "../manage-account/basic-services";
import Subscriptions from "../manage-account/subscriptions";
import PackAndSubscriptions from "../manage-account/pack-and-subscriptions";
import SectionHeader from "../manage-account/section-header";
import ShamelPromo from "../manage-account/shamel-promo";
import CurrentPack from "../manage-account/current-pack";
import UserProfile from "../manage-account/user-profile";
import RemainingInfo from "../manage-account/remaining-info";
import GoUp from "../manage-account/go-up";
import PassportCountriesHome from "../roaming/PassportCountriesHome";
import ShamelProControl from "../manage-account/shamel-pro-control";
// import OoredooAddDLS from "../home/ooredoo-add";
export const getTemplate = (pmsitem, extraData, isNojoomPageMaster, isXpressProfitPageMaster, isManageAccount, linedetailsApi, isRoamingJourney) => {

  switch (pmsitem?.templatetype) {
    case "178":{
      return <BannerCarousel pmsitem={pmsitem} />;
    }
    // case "100": {
    //   return <div className="pse_sm"><NotificationComponent pmsitem={pmsitem} /></div>;
    //   break;
    // }
    // case "169": {
    //   return <div className="pse_sm"><QuicklinksComponent pmsitem={pmsitem} /></div>;
    //   break;
    // }
    case "306": {
      return <div className="pse_sm"><QuicklinksComponent pmsitem={pmsitem} /></div>;
      break;
    }
    case "309":{
      return <div className="pse_sm"><Promotions pmsitem={pmsitem}/></div>
    }
    //ooredoo add
    case "166":{
      return <div className="pse_sm"><OoredooAdd pmsitem={pmsitem}/></div>;
      break;
    }
    //offers for you 
    case "308":{
      return <div className="pse_sm"><OffersForYou pmsitem={pmsitem}/></div>;
      break;
    }
    //Special Offers - RN_Special_Recommendations
    case "154": {
      return <div className="pse_sm"><CardswiperComponent pmsitem={pmsitem} /></div>;
    }
    case "103": {
      return <div className={isNojoomPageMaster ? 'pse_sm mb-5 wm-pb3-6' : 'pse_sm mb-5 wm-pb3-6'}><AccordionComponent pmsitem={pmsitem} isNojoomPageMaster={isNojoomPageMaster}/></div>;
    }
    case "102": {
      return <div className="pse_sm"><DashboardComponent pmsitem={pmsitem} /></div>;
      break;
    }
    case "155": {
      return <div className="pse_sm"><PromoswiperComponent pmsitem={pmsitem} /></div>;
      break;
    }
    case "175": {
      return <div className="pse_sm"><RecentTransactionswiperComponent pmsitem={pmsitem} /></div>;
      break;
    }
    case "109": {
      if(isNojoomPageMaster){
        return (
          <>
          {
            pmsitem?.elementmeta?.isenrolled === 'F' ? (
              <NojoomEnrollNow psmItem={pmsitem} />
            ):
            <>
            <NojoomBanner pmsitem={pmsitem}/>
            {/* This block should not move to sprint14 branch,While merging branch remove this and push to sp14
              <NojoomUserInfo pmsitem={pmsitem} extraData={extraData}/> */}
            </>

          }
          </>
        ) 
      }else if(isXpressProfitPageMaster){
        return <XpressProfitBanner psmItem={pmsitem} />
      }else if(isManageAccount){
        return <Banner psmItem={pmsitem} />
      }else{
        return <PassportCountriesBanner pmsitem={pmsitem} extraData={extraData} isRoamingJourney={isRoamingJourney}/>;
      }
      break;
    }

    case "118": {
      if(isRoamingJourney) {return <div className=""><PassportCountriesHome pmsitem={pmsitem}/></div>}
      else{
      return <PassportCountriesTabs pmsitem={pmsitem} />;
      }

      break;
    }
 
    case '305': {
      // console.log(pmsitem, "roaming multi countries")
      return <RoamingMultiCountriesList pmsitem={pmsitem} extraData={extraData}/>
      break;
    }
    case '124': {
      return <PromoSwiper psmItem={pmsitem} />;
    }
    case '135': {
      // console.log(pmsitem, "roaming multi countries")
      return <MoreAccountsList pmsitem={pmsitem} />
      break;
    }


    case "101": {
      return <div>101</div>;
    }

    // nojoom - user info   
    case "201": {
      return <NojoomUserInfo pmsitem={pmsitem} extraData={extraData} />;
    }
    // nojoom - dashboard
    case "202": {
      return <NojoomDashboard pmsitem={pmsitem} />;
    }

    // xpress profit balance
    case "144": {
      return <XpressProfitBalance pmsitem={pmsitem} />
    }

    // xpress - transfer balance
    case "145": {
      return <TransferBalance pmsitem={pmsitem} />
    }

    // xpress - transaction history
    case "146": {
      return <TransactionHistory pmsitem={pmsitem} />
    }

    // xpress - load balance
    case "147": {
      return <LoadBalance pmsitem={pmsitem} />
    }
     // home - Running out of internet
     case "151": {
      return <OutofInternet pmsitem={pmsitem} />;
    }
    case "311": {
      return <NojoomEarnPoints pmsitem={pmsitem}/>
    }
    case "172": {
      return  <div className="pse_sm"><SmartPayCard psmItem={pmsitem} /></div>
    }

    // manage account specific templates
    // user profile
    case "600":{
      return <div className="pse_sm"><UserProfile /></div>
    }
    // balance
    case "601":{
      return <div className="pse_sm"><BalanceCard /></div>
    }
    // current pack
    case "602":{
      const internetdata = linedetailsApi?.data?.data?.response?.Internet;
      const linedetailminutes = linedetailsApi?.data?.data?.response?.Minutes;
      const linedetailsms = linedetailsApi?.data?.data?.response?.Sms;
      const linedetailroaming = linedetailsApi?.data?.data?.response?.Roaming;

      const isUsageData =  ((internetdata && (internetdata?.Services?.length > 0)) || (linedetailminutes && linedetailminutes?.Services?.length > 0) || (linedetailsms && linedetailsms?.Services?.length > 0) || (linedetailroaming && (linedetailroaming?.Services?.length > 0)));

      return <div className="pse_sm"><CurrentPack isUsageData={isUsageData} /></div>
    }
    // basic services
    case "603":{
      return <div className="pse_sm"><BasicServices /></div>
    }
    // pack_subscriptions
    case "612":{
      return <div className="pse_sm"><PackAndSubscriptions linedetailsApi={linedetailsApi} /></div>
    }
    // subscriptions
    case "605":{
      return <div className="pse_sm"><Subscriptions psmItem={pmsitem} /></div>
    }
    // shamelpromo
    case "611":{
      // return <div><ShamelPromo linedetailsApi={linedetailsApi} /></div>
      return <div className="pse_sm"><ShamelProControl lineDetails={linedetailsApi} /></div>
    }
    // lineheader
    case "606":{
      // return <div className="pse_sm"><SectionHeader psmItem={pmsitem} /></div>
      const internetdata = linedetailsApi?.data?.data?.response?.Internet;
      const linedetailminutes = linedetailsApi?.data?.data?.response?.Minutes;
      const linedetailsms = linedetailsApi?.data?.data?.response?.Sms;
      const linedetailroaming = linedetailsApi?.data?.data?.response?.Roaming;

      const showLineHeader =  ((internetdata && (internetdata?.Services?.length > 0)) || (linedetailminutes && linedetailminutes?.Services?.length > 0) || (linedetailsms && linedetailsms?.Services?.length > 0) || (linedetailroaming && (linedetailroaming?.Services?.length > 0)));

      if(showLineHeader){
        return <div className="pse_sm"><SectionHeader psmItem={pmsitem} /></div>
      }else{
        return <></>
      }
    }
    // linedetails_data
    case "607":{
      return <div className="pse_sm"><RemainingInfo linedetailsApi={linedetailsApi} infotype='data' /></div>
    }
    // linedetails_voice
    case "608":{
      return <div className="pse_sm"><RemainingInfo linedetailsApi={linedetailsApi} infotype='voice' /></div>
    }
    // linedetails_SMS
    case "609":{
      return <div className="pse_sm"><RemainingInfo linedetailsApi={linedetailsApi} infotype='sms' /></div>
    }
    // linedetails_roaming
    case "610":{
      return <div className="pse_sm"><RemainingInfo linedetailsApi={linedetailsApi} infotype='roaming' /></div>
    }
    // linedetails_packs - no such template to render
    case "604":{
      return <></>
    }
    // linedetails_goup
    case "613":{
      return <div className="pse_sm"><GoUp psmItem={pmsitem} /></div>
    }
  }
};
